module.exports=function(scope){ return `<!-- enrollmentIdentifier or FaceMap or image missing in request -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "This endpoint requires valid 'enrollmentIdentifier' or 'faceMap' or 'image' parameters to be passed."
    }
}

<!-- targetAge missing in request -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "The request is missing the targetAge parameter. The targetAge parameter is required. For more information, please visit https://dev.facetec.com/zoomsdk/#/zoom-server-rest-api."
    }
}


<!-- empty enrollmentIdentifier -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "Empty string not valid for parameter enrollmentIdentifier"
    }
}

<!-- empty faceMap -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "Empty string not valid for parameter FaceMap.",
    }
}

<!-- empty image -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "Empty string not valid for parameter image."
    }
}

<!-- invalid enrollmentIdentifier -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "One of the enrollmentIdentifier values was invalid. An enrollmentIdentifier must be a non-empty alphanumeric string. Underscores, hyphens, and emails are also allowed."
    }
}

<!-- enrollmentIdentifier not found in database -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "No entry found in the database for this enrollmentIdentifier."
    }
}

<!-- enrollmentIdentifier must be up to 63 characters-->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "Please provide up to 63 characters for enrollmentIdentifier."
    }
}

<!-- faceMap or image is less then 20 characters -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "Source data length is < 20."
    }
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/restsdk-v2/response/failure/age-check.json.tpl